export const changeCurrencyFormat = (number) => new Intl.NumberFormat().format(number);
